<template>
    <div>
        <buttonlist @exps="exps" ref="SetBtn"></buttonlist>
        <el-tabs @tab-click="tabclick" v-model="SelectIndexs">
            <el-tab-pane :label="$t('getapi[12463]')" name="0">
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[12467]') }}：</td>
                            <td style="width:150px;">
                                <el-date-picker v-model="searchData.time1" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                            </td>
                            <td style="width:60px">{{ $t('getapi[12468]') }}：</td>
                            <td style="width:150px;">
                                <el-date-picker v-model="searchData.time2" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="search(1)" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="invAgingListExportToExecl()" style="margin-left: 8px">{{$t('getapi[6440]')}}{{$t('getapi[922]')}}</el-button>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-table
                        id="table"
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        show-summary
                        :summary-method="getSummaries"
                        :height="200"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :header-cell-style="$limits.headerClass"
                        ref="table"
                >
                    <el-table-column show-overflow-tooltip prop="category_first_name" :label="$t('getapi[1092]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="N0" :label="0+$t('getapi[217]')" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.N0 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="N1" :label="$t('getapi[12469]')" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.N1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="N2" :label="$t('getapi[12470]')" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.N2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="N3" :label="$t('getapi[12471]')" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.N3 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="N4" :label="$t('getapi[12472]')" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.N4 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Total1" :label="Total1label()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.Total1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Total2" :label="Total2label()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.Total2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="dif" :label="data1dif()" align="right">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dif >=0">{{ scope.row.dif | thousandth}}</span>
                            <span v-if="scope.row.dif <0" style="color: red">{{ scope.row.dif | thousandth}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <div id="main" :style="{ width: '100%', height: tableHeight-300 + 'px' }"></div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12464]')" name="1">
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[12467]') }}：</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="searchData1.time1" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                        </td>
                        <td style="width:60px">{{ $t('getapi[12468]') }}：</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="searchData1.time2" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                        </td>
                        <td>
                            <el-button type="primary" size="mini" @click="search(2)" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                        </td>
                    </tr>
                </table>
                <el-table
                        :data="dataSet1"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        show-summary
                        :summary-method="getSummaries"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :header-cell-style="$limits.headerClass"
                        ref="table1"
                >
                    <el-table-column show-overflow-tooltip prop="client_codenew" :label="$t('getapi[2779]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ccp1" :label="data2ccp1()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.ccp1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ycl1" :label="data2ycl1()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.ycl1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="total1" :label="data2total1()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.total1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ccp2" :label="data2ccp2()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.ccp2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ycl2" :label="data2ycl2()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.ycl2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="total2" :label="data2total2()" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.total2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ccpdif" :label="data2ccpdif()" align="right">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ccpdif >=0">{{ scope.row.ccpdif | thousandth}}</span>
                            <span v-if="scope.row.ccpdif <0" style="color: red">{{ scope.row.ccpdif | thousandth}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ycldif" :label="data2ycldif()" align="right">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ycldif >=0">{{ scope.row.ycldif | thousandth}}</span>
                            <span v-if="scope.row.ycldif <0" style="color: red">{{ scope.row.ycldif | thousandth}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="totaldif" :label="data2totaldif()" align="right">
                        <template slot-scope="scope">
                            <span v-if="scope.row.totaldif >=0">{{ scope.row.totaldif | thousandth}}</span>
                            <span v-if="scope.row.totaldif <0" style="color: red">{{ scope.row.totaldif | thousandth}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12465]')" name="2">
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[12467]') }}：</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="searchData2.time1" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                        </td>
                        <td style="width:60px">{{ $t('getapi[12468]') }}：</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="searchData2.time2" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                        </td>
                        <td>
                            <el-button type="primary" size="mini" @click="search(3)" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                        </td>
                    </tr>
                </table>
                <el-table
                        :data="dataSet2"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        show-summary
                        :summary-method="getSummaries2"
                        :height="tableHeight"
                        :cell-class-name="rowClass2"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :header-cell-style="$limits.headerClass"
                        ref="table2"
                >
                    <el-table-column show-overflow-tooltip prop="category_first_name" :label="$t('getapi[169]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_second_name" :label="$t('getapi[170]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_third_name" :label="$t('getapi[171]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ycl1" :label="data3ycl1()" align="right" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.ycl1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ycl2" :label="data3ycl2()" align="right" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.ycl2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="dif" :label="data3ycldif()" align="right" width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dif >=0">{{ scope.row.dif | thousandth}}</span>
                            <span v-if="scope.row.dif <0" style="color: red">{{ scope.row.dif | thousandth}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12466]')" name="3">
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[12467]') }}：</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="searchData3.time1" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                        </td>
                        <td style="width:60px">{{ $t('getapi[12468]') }}：</td>
                        <td style="width:150px;">
                            <el-date-picker v-model="searchData3.time2" popper-class="select-option" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px"></el-date-picker>
                        </td>
                        <td>
                            <el-button type="primary" size="mini" @click="search(4)" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                        </td>
                    </tr>
                </table>
                <el-table
                        :data="dataSet3"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        show-summary
                        :summary-method="getSummaries3"
                        :height="tableHeight"
                        :cell-class-name="rowClass3"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :header-cell-style="$limits.headerClass"
                        ref="table3"
                >
                    <el-table-column show-overflow-tooltip prop="client_codenew" :label="$t('getapi[2779]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_second_name" :label="$t('getapi[170]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_third_name" :label="$t('getapi[171]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="xc1" :label="data4xc1()" align="right" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.xc1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="xc2" :label="data4xc2()" align="right" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.xc2 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="dif" :label="data4xcdif()" align="right" width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dif >=0">{{ scope.row.dif | thousandth}}</span>
                            <span v-if="scope.row.dif <0" style="color: red">{{ scope.row.dif | thousandth}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import echarts from 'echarts';
    import FileSaver from "file-saver";
    import XLSX from "xlsx";
    import 'echarts-gl';
    export default {
        name:'4_invagingweeksum',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                dataSet1: [], // 主表数据
                dataSet2: [], // 主表数据
                dataSet3: [], // 主表数据
                SelectIndexs: 0,
                searchData:{
                    time1:'',
                    time2:'',
                    imagesBase64:''
                },
                searchData1:{
                    time1:'',
                    time2:''
                },
                searchData2:{
                    time1:'',
                    time2:''
                },
                searchData3:{
                    time1:'',
                    time2:''
                },
                userData: [], // 用户信息
                loading: false, // 主表加载状态
            };
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        updated: function(){
            this.$nextTick(() => {
                this.$refs['table'].doLayout();
                this.$refs['table1'].doLayout();
                this.$refs['table2'].doLayout();
                this.$refs['table3'].doLayout();
            })
        },
        methods: {
            Total1label(){
                return this.$t('getapi[12473]')+'\n'+this.searchData.time1
            },
            Total2label(){
                return this.$t('getapi[12473]')+'\n'+this.searchData.time2
            },
            data1dif(){
                return this.$t('getapi[12474]')+'\n'+this.searchData.time1+'~'+this.searchData.time2
            },
            data2ccp1(){
                return this.$t('getapi[238]')+'\n'+this.searchData1.time1
            },
            data2ycl1(){
                return this.$t('getapi[245]')+'\n'+this.searchData1.time1
            },
            data2total1(){
                return this.$t('getapi[12473]')+'\n'+this.searchData1.time1
            },
            data2ccp2(){
                return this.$t('getapi[238]')+'\n'+this.searchData1.time2
            },
            data2ycl2(){
                return this.$t('getapi[245]')+'\n'+this.searchData1.time2
            },
            data2total2(){
                return this.$t('getapi[12473]')+'\n'+this.searchData1.time2
            },
            data2ccpdif(){
                return this.$t('getapi[238]')+'-'+this.$t('getapi[12474]')+'\n'+this.searchData1.time1+'&'+this.searchData1.time2
            },
            data2ycldif(){
                return this.$t('getapi[245]')+'-'+this.$t('getapi[12474]')+'\n'+this.searchData1.time1+'&'+this.searchData1.time2
            },
            data2totaldif(){
                return this.$t('getapi[12473]')+'-'+this.$t('getapi[12474]')+'\n'+this.searchData1.time1+'&'+this.searchData1.time2
            },
            data3ycl1(){
                return this.$t('getapi[12475]')+'\n'+this.searchData2.time1
            },
            data3ycl2(){
                return this.$t('getapi[12475]')+'\n'+this.searchData2.time2
            },
            data3ycldif(){
                return this.$t('getapi[12474]')+'\n'+this.searchData2.time1+'&'+this.searchData2.time2
            },
            data4xc1(){
                return this.$t('getapi[12476]')+'\n'+this.searchData3.time1
            },
            data4xc2(){
                return this.$t('getapi[12476]')+'\n'+this.searchData3.time2
            },
            data4xcdif(){
                return this.$t('getapi[12474]')+'\n'+this.searchData3.time1+'&'+this.searchData3.time2
            },
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('export');
            },
            rowClass2({ row, column, rowIndex, columnIndex }){
                if(row.category_second_name.indexOf('汇总')!= -1){
                    return 'blue'
                }
            },
            rowClass3({ row, column, rowIndex, columnIndex }){
                if(row.client_codenew.indexOf('汇总')!= -1){
                    return 'blue'
                }
            },
            // 查询
            search(type) {
                let that = this;
                if(type == 1){
                    that.getView()
                } else if(type == 2){
                    that.getView1()
                } else if(type == 3){
                    that.getView2()
                } else if(type == 4){
                    that.getView3()
                }
            },
            getView(){
                let that = this
                let parm = that.searchData
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Kpi/GetInvAgingWeekSum', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent && res.DataContent.length > 0){
                            that.dataSet = res.DataContent
                            for(let i=0;i<that.dataSet.length;i++){
                                that.dataSet[i].N0 = Math.round(that.dataSet[i].N0/10000)
                                that.dataSet[i].N1 = Math.round(that.dataSet[i].N1/10000)
                                that.dataSet[i].N2 = Math.round(that.dataSet[i].N2/10000)
                                that.dataSet[i].N3 = Math.round(that.dataSet[i].N3/10000)
                                that.dataSet[i].N4 = Math.round(that.dataSet[i].N4/10000)
                                that.dataSet[i].Total1 = Math.round(that.dataSet[i].Total1/10000)
                                that.dataSet[i].Total2 = Math.round(that.dataSet[i].Total2/10000)
                                that.dataSet[i].dif = Math.round(that.dataSet[i].dif/10000)
                            }
                            that.draw(that.dataSet)
                        } else {
                            that.dataSet = []
                            that.$message.warning(that.$t('getapi[12477]'))
                        }
                    }
                    loadingInstance.close()
                });
            },
            getView1(){
                let that = this
                let parm = that.searchData1
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Kpi/GetInvAmountComp', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent && res.DataContent.length > 0){
                            that.dataSet1 = res.DataContent
                            for(let i=0;i<that.dataSet1.length;i++){
                                that.dataSet1[i].ccp1 = Math.round(that.dataSet1[i].ccp1/10000)
                                that.dataSet1[i].ccp2 = Math.round(that.dataSet1[i].ccp2/10000)
                                that.dataSet1[i].total1 = Math.round(that.dataSet1[i].total1/10000)
                                that.dataSet1[i].ycl1 = Math.round(that.dataSet1[i].ycl1/10000)
                                that.dataSet1[i].ycl2 = Math.round(that.dataSet1[i].ycl2/10000)
                                that.dataSet1[i].total2 = Math.round(that.dataSet1[i].total2/10000)
                                that.dataSet1[i].ccpdif = Math.round(that.dataSet1[i].ccpdif/10000)
                                that.dataSet1[i].ycldif = Math.round(that.dataSet1[i].ycldif/10000)
                                that.dataSet1[i].totaldif = Math.round(that.dataSet1[i].totaldif/10000)
                            }
                        } else {
                            that.dataSet1 = []
                            that.$message.warning(that.$t('getapi[12477]'))
                        }
                    }
                    loadingInstance.close()
                });
            },
            getView2(){
                let that = this
                let parm = that.searchData2
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Kpi/GetInvMaterialAnalysis', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent && res.DataContent.length > 0){
                            for(let i=0;i<res.DataContent.length;i++){
                                res.DataContent[i].ycl1 = Math.round(res.DataContent[i].ycl1/10000)
                                res.DataContent[i].ycl2 = Math.round(res.DataContent[i].ycl2/10000)
                                res.DataContent[i].dif = Math.round(res.DataContent[i].dif/10000)
                            }
                            let newArr = []
                            res.DataContent.forEach(item => {
                                const parent = newArr.find(c => c.category_second_name === item.category_second_name)
                                if (parent) {
                                    parent.childs.push(item)
                                } else {
                                    const obj = {
                                        category_second_name: item.category_second_name,
                                        childs: [item]
                                    }
                                    newArr.push(obj)
                                }
                            })
                            for(let i = 0;i<newArr.length;i++){
                                let ycl1t = 0
                                let ycl2t = 0
                                let dift = 0
                                for(let j=0;j<newArr[i].childs.length;j++){
                                    ycl1t += newArr[i].childs[j].ycl1
                                    ycl2t += newArr[i].childs[j].ycl2
                                    dift += newArr[i].childs[j].dif
                                }
                                newArr[i].childs.push({
                                    category_first_name:newArr[0].category_first_name,
                                    category_second_name:newArr[i].category_second_name + '汇总',
                                    category_third_name:'',
                                    dif:dift,
                                    ycl1:ycl1t,
                                    ycl2:ycl2t
                                })
                            }
                            that.dataSet2 = []
                            for(let i = 0;i<newArr.length;i++){
                                for(let j =0;j<newArr[i].childs.length;j++){
                                    that.dataSet2 = [...that.dataSet2,{
                                        category_first_name:newArr[i].childs[j].category_first_name,
                                        category_second_name:newArr[i].childs[j].category_second_name,
                                        category_third_name:newArr[i].childs[j].category_third_name,
                                        dif:newArr[i].childs[j].dif,
                                        ycl1:newArr[i].childs[j].ycl1,
                                        ycl2:newArr[i].childs[j].ycl2
                                    }]
                                }
                            }
                        } else {
                            that.dataSet2 = []
                            that.$message.warning(that.$t('getapi[12477]'))
                        }
                    }
                    loadingInstance.close()
                });
            },
            getView3(){
                let that = this
                let parm = that.searchData3
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Kpi/GetInvProfileAnalysis', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent && res.DataContent.length > 0){
                            for(let i = 0;i<res.DataContent.length;i++){
                                res.DataContent[i].category_second_name = '型材'
                                res.DataContent[i].xc1 = Math.round(res.DataContent[i].xc1/10000)
                                res.DataContent[i].xc2 = Math.round(res.DataContent[i].xc2/10000)
                                res.DataContent[i].dif = Math.round(res.DataContent[i].dif/10000)
                            }
                            let newArr = []
                            res.DataContent.forEach(item => {
                                const parent = newArr.find(c => c.client_codenew === item.client_codenew)
                                if (parent) {
                                    parent.childs.push(item)
                                } else {
                                    const obj = {
                                        client_codenew: item.client_codenew,
                                        childs: [item]
                                    }
                                    newArr.push(obj)
                                }
                            })
                            console.log(newArr)
                            for(let i = 0;i<newArr.length;i++){
                                let xc1t = 0
                                let xc2t = 0
                                let dift = 0
                                for(let j=0;j<newArr[i].childs.length;j++){
                                    xc1t += newArr[i].childs[j].xc1
                                    xc2t += newArr[i].childs[j].xc2
                                    dift += newArr[i].childs[j].dif
                                }
                                newArr[i].childs.push({
                                    client_codenew:newArr[i].client_codenew + '汇总',
                                    category_second_name:'',
                                    category_third_name:'',
                                    dif:dift,
                                    xc1:xc1t,
                                    xc2:xc2t
                                })
                            }
                            console.log(newArr)
                            that.dataSet3 = []
                            for(let i = 0;i<newArr.length;i++){
                                for(let j =0;j<newArr[i].childs.length;j++){
                                    that.dataSet3 = [...that.dataSet3,{
                                        client_codenew:newArr[i].childs[j].client_codenew,
                                        category_second_name:newArr[i].childs[j].category_second_name,
                                        category_third_name:newArr[i].childs[j].category_third_name,
                                        dif:newArr[i].childs[j].dif,
                                        xc1:newArr[i].childs[j].xc1,
                                        xc2:newArr[i].childs[j].xc2
                                    }]
                                }
                            }
                        } else {
                            that.dataSet3 = []
                            that.$message.warning(that.$t('getapi[12477]'))
                        }
                    }
                    loadingInstance.close()
                });
            },
            // 图标
            draw(data){
                let that = this;
                let list = {
                    datax:[],
                    data1:[],
                    data2:[],
                    data3:[],
                    data4:[],
                    data5:[]
                }
                if(data.length == 0){
                    return
                } else {
                    list.datax = [this.$t('getapi[12469]'),this.$t('getapi[12470]'),this.$t('getapi[12471]'),this.$t('getapi[12472]')]
                    for(let i = 0;i<data.length;i++){
                        if(data[i]['category_first_name'] == '原材料'){
                            list.data1 = [data[i]['N1'],data[i]['N2'],data[i]['N3'],data[i]['N4'],]
                        }
                        if(data[i]['category_first_name'] == '固定资产'){
                            list.data2 = [data[i]['N1'],data[i]['N2'],data[i]['N3'],data[i]['N4'],]
                        }
                        if(data[i]['category_first_name'] == '半成品'){
                            list.data3 = [data[i]['N1'],data[i]['N2'],data[i]['N3'],data[i]['N4'],]
                        }
                        if(data[i]['category_first_name'] == '产成品'){
                            list.data4 = [data[i]['N1'],data[i]['N2'],data[i]['N3'],data[i]['N4'],]
                        }
                        if(data[i]['category_first_name'] == '低值易耗品'){
                            list.data5 = [data[i]['N1'],data[i]['N2'],data[i]['N3'],data[i]['N4'],]
                        }
                    }
                }
                that.charts = echarts.init(document.getElementById("main"));
                let option = {
                    title: {
                        text: this.$t('getapi[12463]'),
                        x:'left',
                        y:'top',
                        textAlign:'left'
                    },
                    xAxis: {
                        type: 'category',
                        label: {
                            show: true,
                            position: 'insideRight'
                        },
                        data: list.datax
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        },
                    },
                    legend: {
                        data: ['原材料', '固定资产', '半成品', '产成品','低值易耗品']
                    },
                    series: [{
                        name:'原材料',
                        data: list.data1,
                        type: 'line',
                        showBackground: true,
                        stack:'',
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                    },
                        {
                            name:'固定资产',
                            data: list.data2,
                            type: 'line',
                            showBackground: true,
                            stack:'',
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            name:'半成品',
                            data: list.data3,
                            type: 'line',
                            showBackground: true,
                            stack:'',
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },{
                            name:'产成品',
                            data: list.data4,
                            type: 'line',
                            showBackground: true,
                            stack:'',
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },{
                            name:'低值易耗品',
                            data: list.data5,
                            type: 'line',
                            showBackground: true,
                            stack:'',
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        }]
                }
                that.charts.clear();
                that.charts.setOption(option);
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] = sums[index].toString().replace(/\d+/, function(n){ // 先提取整数部分
                            return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                                return $1+",";
                            });
                        });
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                return sums
            },
            getSummaries2(){
                let that = this
                let ycl1t = 0
                let ycl2t = 0
                let dift = 0
                for(let i=0;i<that.dataSet2.length;i++){
                    if(that.dataSet2[i].category_second_name.indexOf('汇总')!=-1){
                        ycl1t += that.dataSet2[i].ycl1
                        ycl2t += that.dataSet2[i].ycl2
                        dift += that.dataSet2[i].dif
                    }
                }
                return ['合计','','',ycl1t,ycl2t,dift]
            },
            getSummaries3(){
                let that = this
                let xc1t = 0
                let xc2t = 0
                let dift = 0
                for(let i=0;i<that.dataSet3.length;i++){
                    if(that.dataSet3[i].client_codenew.indexOf('汇总')!=-1){
                        xc1t += that.dataSet3[i].xc1
                        xc2t += that.dataSet3[i].xc2
                        dift += that.dataSet3[i].dif
                    }
                }
                return ['合计','','',xc1t,xc2t,dift]
            },
            tabclick(tab){
                let that = this;
                that.SelectIndexs = tab.name;
            },
            exps(){
                let that =this
                if(that.SelectIndexs == 0){
                    that.invAgingWeekSumExportToExecl()
                } else if(that.SelectIndexs == 1){
                    that.invAmountCompExportToExecl()
                } else if(that.SelectIndexs == 2){
                    that.invMaterialAnalysisExportToExecl()
                } else if(that.SelectIndexs == 3){
                    that.invProfileAnalysisExportToExecl()
                }
            },
            invAgingWeekSumExportToExecl(){
                let that = this
                let loadingInstance = Loading.service(Common.maskoption1);
                that.searchData.imagesBase64 = that.charts.getDataURL('png')
                let parm = that.searchData
                that.$http.urlpost('/Kpi/invAgingWeekSumExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    loadingInstance.close()
                });
                /*let wb = XLSX.utils.table_to_book(document.querySelector('#table'),{raw:true});   // 这里就是表格
                let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
                try {
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), that.$t("getapi[12463]")+'.xlsx');  //table是自己导出文件时的命名，随意
                } catch (e)
                {
                    if (typeof console !== 'undefined')
                        console.log(e, wbout)
                }
                return wbout*/
            },
            invAmountCompExportToExecl(){
                let that = this
                let loadingInstance = Loading.service(Common.maskoption1);
                let parm = that.searchData1
                that.$http.urlpost('/Kpi/invAmountCompExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    loadingInstance.close()
                });
            },
            invMaterialAnalysisExportToExecl(){
                let that = this
                let loadingInstance = Loading.service(Common.maskoption1);
                let parm = that.searchData2
                that.$http.urlpost('/Kpi/invMaterialAnalysisExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    loadingInstance.close()
                });
            },
            invProfileAnalysisExportToExecl(){
                let that = this
                let loadingInstance = Loading.service(Common.maskoption1);
                let parm = that.searchData3
                that.$http.urlpost('/Kpi/invProfileAnalysisExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    loadingInstance.close()
                });
            },
            invAgingListExportToExecl(){
                let that = this
                if(that.searchData.time1 == '' || that.searchData.time2 == ''){
                    that.$message.warning(that.$t('getapi[9430]'))
                    return
                }
                let loadingInstance = Loading.service(Common.maskoption1);
                let parm = that.searchData
                that.$http.urlpost('/Kpi/invAgingListExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    loadingInstance.close()
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .bbl {
        margin: 0px auto 10px;
        white-space: pre;
        span {
            margin-left: 10px;
            min-width: 70px;
            text-align: left;
            line-height: 20px;
            display: inline-block;
            margin-right: 0px;
        }
    }
    /deep/ .blue{
        background: #9dd9ff
    }
</style>
